


// import React, { memo, useContext, useEffect, useState } from "react";import LoadMachine from "../../../../../components/dashboard/tab1Component/LoadMachine";
// import "../../dashboard/dashboardTabs/tab4Content/DashboardTap4Content.css";
// import { Box, Card, CardActions, CardHeader, Container, CssBaseline, Grid, IconButton, Paper, Stack, Typography, colors, useTheme, useMediaQuery } from '@mui/material';
// import Solarpic from "../../../../../assets/img/logos/solarpic.png";
// import Load from "../../../../../assets/img/logos/load.png";
// import Grid1 from "../../../../../assets/img/logos/grid.png";
// import Watch from "../../../../../assets/img/logos/solar_dg.jpg";
// import SolarMeter from "../../../../../assets/img/logos/solar_meter.png";
// import Kusum from "../../../../../assets/img/logos/kusumDash.png";

// import { logApi, MainSumApi } from "../../../../../api/Api";

// import TempInfoStrip from '../../../../../components/dashboard/TempInfoStrip';

// import { InverterContext } from '../../../../../context/InverterContext';
// import { AppThemeContext } from '../../../../../context/AppThemeContext';
// import backgroundImage from '../../../../../assets/img/bg/chart2.png';
// import { AuthenticationContext } from '../../../../../context/AuthenticationContext'

// import SettingsIcon from '@mui/icons-material/Settings';

// import AutorenewIcon from '@mui/icons-material/Autorenew';
// import PolarAreaChart from "../../../../../components/charts/tab2Chart/PolarAreaChart";
// import SolarSvg2 from "../../../../../assets/svg/lastSolarSvg2";
// import MainSlider from "../../dashboard/dashboardTabs/tab4Content/MainSlider";
// import BottomSlider from "../../dashboard/dashboardTabs/tab4Content/BottomSlider";
// import { getDateTimeForDashboardTab1, getFromTo } from '../../../../../utils'

// import AppModal from "../../../../../components/AppModal";
// import InvverterFullSize from "../../../../../components/inverter/InvverterFullSize";

// import TopHeader from "../../../../../components/general/TopHeader";
// import SolarImageSvg from "../../../../../assets/svg/SolarImageSvg";
// import PlantEnergy from "../../dashboard/dashboardTabs/tab4Content/plantEnergy/PlantEnergy";
// import TempInfoWms from "../../../../../components/dashboard/TempInfoWms";
// import Tab4MonthlyEnergy from "../../dashboard/dashboardTabs/tab4Content/tab4MonthlyEnergy/Tab4MonthlyEnergy";
// import LastSolarSvg from "../../../../../assets/svg/LastSolarSvg";




// function DashboardKusumTab1() {

//     const isMobile = useMediaQuery('(max-width:600px)');
//     const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const { spacing, palette, shape: { borderRadius } } = useTheme();
//     const { getHYBRD_Info, HYBRD_DATA_POWER_Loading, HYBRD_DATA_INFO, getPostKwhHybridForDashboard, getHYBRD_Power, HYBRD_DATA_POWER, POST_KWH_HYBRID_DATA_DASHBOARD } = useContext(InverterContext);

//     const [logData, setLogData] = useState([]);
//     const [mainData, setMainData] = useState([]);
//     const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
//     const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)

//     const [OpenMix, setOpenMix] = useState(false);
//     const handleOpenMix = () => setOpenMix(true);
//     const handleCloseMix = () => setOpenMix(false);

//     const [credentials, setCredentials] = useState({
//         LOGIN_ID: localStorage.getItem("LoginID"),
//         LOC_CODE: localStorage.getItem("LCODE"),
//         PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//         WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//     });


//     const [sumCredentials, setSumCredentials] = useState({
//         LOGIN_ID: localStorage.getItem("LoginID") || "",
//         PASS_KEY: localStorage.getItem("KEY") || "xyz",
//         LCODE: localStorage.getItem("LCODE") || "",
//         DT1: StartDate,
//         DT2: EndDate,
//         TYP: "A",
//         WEB_KEY: "WEBXYZ321",
//         FID: "216HT001",
//     });



//     // this is fetching for MIDDLE data
//     const fetchLogData = async () => {
//         const res = await logApi(credentials);
//         if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
//             setLogData(res.TOT_LIVE_KW_NEW);
//         } else {
//             setLogData([]);
//         }
//     };

//     // useEffect(() => {
//     //     fetchLogData();
//     // }, [credentials]); // Fetch new data when credentials change


//     // this is fetching for MAIN_SUM
//     const fetchData = async () => {
//         const res = await MainSumApi(sumCredentials);
//         if (res?.KWH_MIS_MAIN_SUM && Array.isArray(res.KWH_MIS_MAIN_SUM)) {
//             setMainData(res.KWH_MIS_MAIN_SUM);
//         } else {
//             setMainData([]);
//         }
//     };

//     // useEffect(() => {
//     //     fetchData();
//     // }, [sumCredentials]); // Fetch new data when credentials change

//     useEffect(() => {
//         // Fetch data immediately on mount
//         fetchLogData();
//         fetchData();

//         // Set interval to fetch data every 30 seconds
//         const interval = setInterval(() => {
//             fetchLogData();
//             fetchData();
//         }, 30000); // 30 seconds in milliseconds

//         // Cleanup interval on unmount
//         return () => clearInterval(interval);
//     }, [credentials, sumCredentials]); // Dependencies to trigger re-setup if these values change



//     const blinkingAnimationDateTime = {
//         fontWeight: "900",
//         animation: 'blinkingAnimationDateTime 2s infinite',
//         transition: 'color 0.5s ease-in-out',
//     }
//     const blinkingAnimationBatteryStatusCharging = {
//         fontWeight: "900",
//         animation: 'blinkingAnimationDateTime 2s infinite',
//         transition: 'color 0.5s ease-in-out',
//         color: 'green'
//     }
//     const blinkingAnimationBatteryStatusDischarging = {
//         fontWeight: "900",
//         animation: 'blinkingAnimationDateTime 2s infinite',
//         transition: 'color 0.5s ease-in-out',
//         color: 'red'
//     }

//     const styles = {
//         IconStyle: {
//             color: 'primary.main',
//             fontSize: '1rem'
//         }
//     }

//     return (

//         <>
//             {/* {LoggedInUserInfo.MNU_WMS === "1" ? (
//                 <TempInfoStrip />
//             ) : null} */}

//             {LoggedInUserInfo.MNU_WMS === "1" && LoggedInUserInfo.USER_CATEGORY !== "WMS" && (
//                 <TempInfoWms />
//             )}


//             <div className="w-100 " style={{ backgroundColor: "white" }}>
//                 <div className="row g-0"> {/* Use g-0 to remove horizontal gaps */}

//                     <div className="col g-1">
//                         <div className="first_total">
//                             <div className="card text-center">
//                                 <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
//                                     <strong>Annual Target</strong>
//                                 </div>
//                                 <div className="card-body px-2">
//                                     {mainData.map((item, indx) => (
//                                         <div className="text-start" key={indx}>
//                                             <p>Target&nbsp;:&nbsp;<span style={{ fontSize: "1.2rem", color: "#013b7b" }}>
//                                                 {item.Target !== undefined ? item.Target : "N/A"}
//                                             </span>&nbsp;
//                                                 <span style={{ color: "red" }}>{item.Target_unit !== undefined ? item.Target_unit : "N/A"}</span></p>

//                                             &nbsp;

//                                             <p>Achieved&nbsp;:&nbsp;<span style={{ fontSize: "1.2rem", color: "#013b7b" }}>
//                                                 {item.Achieved !== undefined ? item.Achieved : "N/A"}
//                                             </span>&nbsp;
//                                                 <span style={{ color: "red" }}>{item.Target_unit !== undefined ? item.Target_unit : "N/A"}</span></p>
//                                             &nbsp;

//                                             <p>Target&nbsp;Achieved&nbsp;:&nbsp;<span style={{ fontSize: "1.2rem", color: "#013b7b" }}>
//                                                 {item.Achieved_per !== undefined ? item.Achieved_per : "N/A"}
//                                             </span>
//                                             </p>

//                                         </div>
//                                     ))}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="col g-1">
//                         <div className="first_total">
//                             <div className="card text-center">
//                                 <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
//                                     <strong>Solar Yield</strong>
//                                 </div>
//                                 <div className="card-body px-2">
//                                     <div>
//                                         <img
//                                             style={{ display: "flex", marginBottom: "1rem" }}
//                                             src={Solarpic}
//                                             alt="Solarpic"
//                                             className="dashboard-icon"
//                                         />

//                                         {logData.map((log, index) => (
//                                             <div className='d-flex align-items-center my-1' key={index}>
//                                                 <p style={{ fontSize: "14px" }}>

//                                                     <span style={{ fontSize: "1.4rem", color: "#013b7b" }}>
//                                                         {log.SOLAR !== undefined ? log.SOLAR : "N/A"}
//                                                     </span>&nbsp;&nbsp;
//                                                     <span style={{ color: "red" }}>kW</span>
//                                                 </p>
//                                             </div>
//                                         ))}
//                                     </div>

//                                     {mainData.map((item, indx) => (
//                                         <div className="text-end" key={indx}>
//                                             <p>Today Yield</p>
//                                             <p>
//                                                 <span className="bold" style={{ color: "#013b7b" }}>
//                                                     {item.SOLAR_DAY !== undefined ? item.SOLAR_DAY : "N/A"}&nbsp;

//                                                 </span>
//                                                 <span>kWh</span>
//                                             </p>
//                                             <p>Total Yield</p>
//                                             <p>
//                                                 <span className="bold" style={{ color: "#013b7b" }}>
//                                                     {item.SOLAR_TOTAL !== undefined ? item.SOLAR_TOTAL : "N/A"}&nbsp;

//                                                 </span>
//                                                 <span>kWh</span>
//                                             </p>

//                                         </div>
//                                     ))}


//                                 </div>
//                             </div>
//                         </div>
//                     </div>



//                     <div className="col g-1">
//                         <div className="first_total">
//                             <div className="card text-center">
//                                 <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
//                                     <strong>Solar Meter</strong>
//                                 </div>
//                                 <div className="card-body px-2">
//                                     <div><img style={{ display: "flex", marginBottom: "1rem", borderRadius: "1rem" }} src={SolarMeter} alt="grid" className="dashboard-icon" />
//                                         {logData.map((log, index) => (
//                                             <div className='d-flex align-items-center' key={index}><p style={{ fontSize: "14px" }}>
//                                                 <span style={{ fontSize: "1.4rem", color: "#013b7b" }}>
//                                                     {log.SOLAR_MT !== undefined ? log.SOLAR_MT : "N/A"}
//                                                 </span>&nbsp;&nbsp;
//                                                 <span style={{ color: "red" }}>kW</span></p>
//                                             </div>
//                                         ))}
//                                     </div>


//                                     {mainData.map((item, indx) => (
//                                         <div className="text-end" key={indx}>
//                                             <p>Today </p>
//                                             <p>
//                                                 <span className="bold" style={{ color: "#013b7b" }}>
//                                                     {item.SOLAR_DAY_MT !== undefined ? item.SOLAR_DAY_MT : "N/A"}&nbsp;

//                                                 </span>
//                                                 <span>kWh</span>
//                                             </p>
//                                             <p>Total </p>
//                                             <p>
//                                                 <span className="bold" style={{ color: "#013b7b" }}>
//                                                     {item.SOLAR_TOTAL_MT !== undefined ? item.SOLAR_TOTAL_MT : "N/A"}&nbsp;

//                                                 </span>
//                                                 <span>kWh</span>
//                                             </p>

//                                         </div>
//                                     ))}


//                                 </div>
//                             </div>
//                         </div>
//                     </div>



//                     <div className="col g-1">
//                         <div className="first_total">
//                             <div className="card text-center">
//                                 <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
//                                     <strong>Main ABT Meter</strong>
//                                 </div>
//                                 <div className="card-body px-2">
//                                     <div><img style={{ display: "flex", marginBottom: "1rem" }} src={Grid1} alt="watch" className="dashboard-icon" />
//                                         {logData.map((log, index) => (
//                                             <div className='d-flex align-items-center' key={index}><p style={{ fontSize: "14px" }}>
//                                                 <span style={{ fontSize: "1.4rem", color: "#013b7b" }}>
//                                                     {log.NET_MT !== undefined ? log.NET_MT : "N/A"}
//                                                 </span>&nbsp;&nbsp;
//                                                 <span style={{ color: "red" }}>kW</span></p>
//                                             </div>
//                                         ))}
//                                     </div>



//                                     {mainData.map((item, indx) => (
//                                         <div className="text-end" key={indx}>
//                                             <p>Today </p>
//                                             <p>
//                                                 <span className="bold" style={{ color: "#013b7b" }}>
//                                                     {item.NET_DAY_MT !== undefined ? item.NET_DAY_MT : "N/A"}&nbsp;

//                                                 </span>
//                                                 <span>kWh</span>
//                                             </p>
//                                             <p>Total </p>
//                                             <p>
//                                                 <span className="bold" style={{ color: "#013b7b" }}>
//                                                     {item.NET_TOTAL_MT !== undefined ? item.NET_TOTAL_MT : "N/A"}&nbsp;

//                                                 </span>
//                                                 <span>kWh</span>
//                                             </p>

//                                         </div>
//                                     ))}

//                                 </div>
//                             </div>
//                         </div>
//                     </div>



//                     <div className="col g-1">
//                         <div className="first_total" >
//                             <div className="card text-center">
//                                 <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
//                                     <strong>Check Meter</strong>
//                                 </div>


//                                 <div className="card-body px-2">
//                                     <div><img style={{ display: "flex", marginBottom: "1rem" }} src={Grid1} alt="watch" className="dashboard-icon" />
//                                         {logData.map((log, index) => (
//                                             <div className='d-flex align-items-center' key={index}>
//                                                 <p style={{ fontSize: "14px" }}>
//                                                     <span style={{ fontSize: "1.4rem", color: "#013b7b" }}>
//                                                         {log.CHECK_MT !== undefined ? log.CHECK_MT : "N/A"}
//                                                     </span>&nbsp;&nbsp;
//                                                     <span style={{ color: "red" }}>kW</span></p>
//                                             </div>
//                                         ))}
//                                     </div>



//                                     {mainData.map((item, indx) => (
//                                         <div className="text-end" key={indx}>
//                                             <p>Today </p>
//                                             <p>
//                                                 <span className="bold" style={{ color: "#013b7b" }}>
//                                                     {item.CHECK_DAY_MT !== undefined ? item.CHECK_DAY_MT : "N/A"}&nbsp;

//                                                 </span>
//                                                 <span>kWh</span>
//                                             </p>
//                                             <p>Total </p>
//                                             <p>
//                                                 <span className="bold" style={{ color: "#013b7b" }}>
//                                                     {item.CHECK_TOTAL_MT !== undefined ? item.CHECK_TOTAL_MT : "N/A"}&nbsp;

//                                                 </span>
//                                                 <span>kWh</span>
//                                             </p>

//                                         </div>
//                                     ))}

//                                 </div>


//                             </div>
//                         </div>
//                     </div>



//                     {mainData.map((log, index) => (
//                         <div className="col g-1" key={index}>
//                             <div className="first_total">
//                                 <div className="card">
//                                     <div className="card-header text-center" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
//                                         <strong>Today's Performance</strong>
//                                     </div>
//                                     <div className="card-body px-3">

//                                         <div className="d-flex justify-content-start w-100">


//                                             <div className="leftdiv">
//                                                 <p><span>CUF</span> &nbsp;<span style={{ fontSize: "1rem", color: "#013b7b" }}>
//                                                     {log.CUF !== undefined ? log.CUF : "N/A"}
//                                                 </span>&nbsp;
//                                                     <span className=""> PR</span>&nbsp;
//                                                     <span style={{ fontSize: "1rem", color: "#013b7b" }}>
//                                                         {log.PR !== undefined ? log.PR : "N/A"}
//                                                     </span>
//                                                 </p>


//                                                 <p><span>Expected[kWh]</span>&nbsp;
//                                                     <span style={{ fontSize: "1rem", color: "#013b7b" }}>
//                                                         {log["EXPECT_GEN[KWH]"] !== undefined ? log["EXPECT_GEN[KWH]"] : "N/A"}

//                                                     </span>
//                                                 </p>
//                                                 <p><span>Peak&nbsp;Irradiance[W/m²]</span>&nbsp;
//                                                     <span style={{ fontSize: "1rem", color: "#013b7b" }}>
//                                                         {log.PEAK_IRRADIANCE !== undefined ? log.PEAK_IRRADIANCE : "N/A"}
//                                                     </span>
//                                                 </p>
//                                                 <p><span>Peak&nbsp;Irr&nbsp;Time</span>&nbsp;
//                                                     <span style={{ fontSize: "1rem", color: "#013b7b" }}>
//                                                         {log.PEAK_IRR_TIME !== undefined ? log.PEAK_IRR_TIME : "N/A"}
//                                                     </span>
//                                                 </p>
//                                             </div>
//                                         </div>

//                                     </div>

//                                 </div>
//                             </div>
//                         </div>
//                     ))}



//                 </div>
//             </div>


//             {/* <SolarSvg1 svgColor={palette.primary.main} /> */}



//             <Grid container style={{ padding: "0", margin: "0" }}>
//                 {logData.map((log, index) => (
//                     <Grid item xs={12} sm={12} md={12} lg={6} xl={6} padding={spacing(0)}>
//                         <Container sx={{ maxWidth: '100%', height: '90%', position: 'relative' }}>


//                             <SolarImageSvg svgColor={palette.primary.main} />


//                             <Typography variant='body2' sx={{ position: 'absolute', top: '3%', left: '2%', color: "red" }} className="blink">
//                                 {log.IRR !== undefined ? log.IRR : "N/A"} W/m<sup>2</sup>
//                             </Typography>

//                             <Typography variant='body2' sx={{ position: 'absolute', top: '51%', left: '7%', color: "red" }} className="blink">
//                                 {log.PLANT_2 !== undefined ? log.PLANT_2 : "N/A"}
//                             </Typography>

//                             {/* <Typography variant='body2' sx={{ position: 'absolute', top: '5.5%', right: '13%', color: "red" }} >
//                                 <img style={{ borderRadius: "1rem", height: "4.5rem", width: "9rem" }} src={Kusum} alt="grid" />
//                             </Typography> */}

//                             <Typography
//                                 variant="body2"
//                                 sx={{
//                                     position: "absolute",
//                                     // top: "30%",
//                                     // left: "20%",
//                                     top: "11%", left: "42%",
//                                     color: "red", // Apply red color directly via sx
//                                 }}
//                                 className="blink" // Add the blink class for animation
//                             >
//                                 {log.SOLAR !== undefined ? log.SOLAR : "N/A"} Kw
//                             </Typography>


//                             <Typography variant="body2" sx={{ position: "absolute", top: "42%", left: "42%", }}>
//                                 Solar Meter
//                             </Typography>

//                             <Typography variant="body2" sx={{ position: "absolute", top: "15%", left: "42%", }}>
//                                 Inverters
//                             </Typography>

//                             <Typography
//                                 variant="body2"
//                                 sx={{
//                                     position: "absolute",
//                                     top: "5%",
//                                     right: "20%",
//                                     color:
//                                         log.PLANT_STATUS?.toLowerCase() === "plant online"
//                                             ? "green"
//                                             : log.PLANT_STATUS?.toLowerCase() === "plant offline"
//                                                 ? "red"
//                                                 : "inherit", // fallback if status is something else or undefined
//                                 }}
//                             >
//                                 {log.PLANT_STATUS !== undefined ? log.PLANT_STATUS : "N/A"}
//                             </Typography>



//                             <Typography variant='body2' sx={{ position: 'absolute', top: '"34%"', left: '0%' }}>
//                                 Power To Building
//                             </Typography>


//                             <Typography variant='body2' sx={{ position: 'absolute', top: '"34%"', left: '25%' }}>
//                                 MainService Panel
//                             </Typography>

//                             <Typography variant='body2' sx={{ position: 'absolute', top: '"34%"', left: '51%' }}>
//                                 Check Meter
//                             </Typography>

//                             <Typography variant='body2' sx={{ position: 'absolute', top: '"34%"', left: '69%' }}>
//                                 Main Meter
//                             </Typography>

//                             <Typography variant='body2' sx={{ position: 'absolute', top: '"34%"', right: '5%' }}>
//                                 Grid
//                             </Typography>


//                             <Typography variant='body2' sx={{ position: 'absolute', bottom: '32%', left: '29%' }}  >
//                                 Line
//                             </Typography>

//                             <Typography variant='body2' sx={{ position: 'absolute', bottom: '32%', left: '36%' }}  >
//                                 Loss
//                             </Typography>

//                             <Typography variant='body2' sx={{ position: 'absolute', bottom: '32%', left: '43%', color: "red" }} className="blink" >
//                                 {log.NET_LOSS !== undefined ? log.NET_LOSS : "N/A"} Kw
//                             </Typography>



//                             <Typography variant='body2' sx={{ position: 'absolute', top: '35%', right: '50%', color: "red" }} className="blink" >
//                                 {log.SOLAR_MT !== undefined ? log.SOLAR_MT : "N/A"} kW
//                             </Typography>

//                             <Typography variant='body2' sx={{ position: 'absolute', top: '54%', right: '17%', color: "red" }} className="blink" >
//                                 {log.NET_FEQ !== undefined ? log.NET_FEQ : "N/A"} &nbsp;
//                                 Hz
//                             </Typography>



//                             <Typography variant='body2' sx={{ position: 'absolute', bottom: '25%', right: '43%', color: "red" }} className="blink" >
//                                 {log.CHECK_MT !== undefined ? log.CHECK_MT : "N/A"} Kw
//                             </Typography>


//                             <Typography variant='body2' sx={{ position: 'absolute', bottom: '25%', right: '26%', color: "red" }} className="blink" >
//                                 {log.NET_MT !== undefined ? log.NET_MT : "N/A"} Kw
//                             </Typography>


//                         </Container>
//                     </Grid>
//                 ))}


//                 <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={{ overflow: 'hidden' }}>

//                     <Stack rowGap={spacing(0)} sx={{ marginTop: '.4rem', overflow: 'hidden' }}>

//                         <Stack
//                             component={Card}
//                             p={spacing(1)}
//                             sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(2) }}
//                         >
//                             <MainSlider />
//                         </Stack>

//                         <Tab4MonthlyEnergy />
//                         {/* <Stack component={Card} p={spacing(1)} sx={{ height: '19rem', overflow: 'hidden' }}>

//                             <Tab4MonthlyEnergy />

//                         </Stack> */}
//                     </Stack>


//                 </Grid>

//                 <Grid item xs={12} sm={12} md={12} lg={12} xl={12} padding={spacing(0)}>

//                     <Stack
//                         component={Card}
//                         p={spacing(1)}
//                         sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(2) }}
//                     >
//                         <PlantEnergy />
//                     </Stack>
//                 </Grid>


//             </Grid>

//             <BottomSlider />

//         </>
//     );
// }


// export default memo(DashboardKusumTab1)






import React, { memo, useContext, useEffect, useState } from "react"; import LoadMachine from "../../../../../components/dashboard/tab1Component/LoadMachine";
import "../../dashboard/dashboardTabs/tab4Content/DashboardTap4Content.css";
import { Box, Card, CardActions, CardHeader, Container, CssBaseline, Grid, IconButton, Paper, Stack, Typography, colors, useTheme, useMediaQuery } from '@mui/material';
import Solarpic from "../../../../../assets/img/logos/solarpic.png";
import Load from "../../../../../assets/img/logos/load.png";
import Grid1 from "../../../../../assets/img/logos/grid.png";
import Watch from "../../../../../assets/img/logos/solar_dg.jpg";
import SolarMeter from "../../../../../assets/img/logos/solar_meter.png";
import Kusum from "../../../../../assets/img/logos/kusumDash.png";

import { logApi, MainSumApi } from "../../../../../api/Api";

import TempInfoStrip from '../../../../../components/dashboard/TempInfoStrip';

import { InverterContext } from '../../../../../context/InverterContext';
import { AppThemeContext } from '../../../../../context/AppThemeContext';
import backgroundImage from '../../../../../assets/img/bg/chart2.png';
import { AuthenticationContext } from '../../../../../context/AuthenticationContext'

import SettingsIcon from '@mui/icons-material/Settings';

import AutorenewIcon from '@mui/icons-material/Autorenew';
import PolarAreaChart from "../../../../../components/charts/tab2Chart/PolarAreaChart";
import SolarSvg2 from "../../../../../assets/svg/lastSolarSvg2";
import MainSlider from "../../dashboard/dashboardTabs/tab4Content/MainSlider";
import BottomSlider from "../../dashboard/dashboardTabs/tab4Content/BottomSlider";
import { getDateTimeForDashboardTab1, getFromTo } from '../../../../../utils'

import AppModal from "../../../../../components/AppModal";
import InvverterFullSize from "../../../../../components/inverter/InvverterFullSize";

import TopHeader from "../../../../../components/general/TopHeader";
import SolarImageSvg from "../../../../../assets/svg/SolarImageSvg";
import PlantEnergy from "../../dashboard/dashboardTabs/tab4Content/plantEnergy/PlantEnergy";
import TempInfoWms from "../../../../../components/dashboard/TempInfoWms";
import Tab4MonthlyEnergy from "../../dashboard/dashboardTabs/tab4Content/tab4MonthlyEnergy/Tab4MonthlyEnergy";
import LastSolarSvg from "../../../../../assets/svg/LastSolarSvg";




function DashboardKusumTab1() {

    const isMobile = useMediaQuery('(max-width:600px)');
    const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
    const { PrimaryColor } = useContext(AppThemeContext);
    const { spacing, palette, shape: { borderRadius } } = useTheme();
    const { getHYBRD_Info, HYBRD_DATA_POWER_Loading, HYBRD_DATA_INFO, getPostKwhHybridForDashboard, getHYBRD_Power, HYBRD_DATA_POWER, POST_KWH_HYBRID_DATA_DASHBOARD } = useContext(InverterContext);

    const [logData, setLogData] = useState([]);
    const [mainData, setMainData] = useState([]);
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)

    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);

    const [credentials, setCredentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID"),
        LOC_CODE: localStorage.getItem("LCODE"),
        PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
        WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
    });


    const [sumCredentials, setSumCredentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID") || "",
        PASS_KEY: localStorage.getItem("KEY") || "xyz",
        LCODE: localStorage.getItem("LCODE") || "",
        DT1: StartDate,
        DT2: EndDate,
        TYP: "A",
        WEB_KEY: "WEBXYZ321",
        FID: "216HT001",
    });



    // this is fetching for MIDDLE data
    const fetchLogData = async () => {
        const res = await logApi(credentials);
        if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
            setLogData(res.TOT_LIVE_KW_NEW);
        } else {
            setLogData([]);
        }
    };

    // useEffect(() => {
    //     fetchLogData();
    // }, [credentials]); // Fetch new data when credentials change


    // this is fetching for MAIN_SUM
    const fetchData = async () => {
        const res = await MainSumApi(sumCredentials);
        if (res?.KWH_MIS_MAIN_SUM && Array.isArray(res.KWH_MIS_MAIN_SUM)) {
            setMainData(res.KWH_MIS_MAIN_SUM);
        } else {
            setMainData([]);
        }
    };



    // useEffect(() => {
    //     // Fetch data immediately on mount
    //     fetchLogData();
    //     fetchData();

    //     // Set interval to fetch data every 30 seconds
    //     const interval = setInterval(() => {
    //         fetchLogData();
    //         fetchData();
    //     }, 60000); // 30 seconds in milliseconds

    //     // Cleanup interval on unmount
    //     return () => clearInterval(interval);
    // }, [credentials, sumCredentials]); 


    // ---------- 1) fetchLogData → refresh every 60 sec ----------
    useEffect(() => {
        // run on mount + when dependency changes
        fetchLogData();

        const interval = setInterval(() => {
            fetchLogData();
        }, 60000); // 60 sec

        return () => clearInterval(interval);
    }, [credentials, sumCredentials]);


    // ---------- 2) fetchData → refresh every 5 min ----------
    useEffect(() => {
        // run on mount + when dependency changes
        fetchData();

        const interval = setInterval(() => {
            fetchData();
        }, 300000); // 5 minutes = 300000 ms

        return () => clearInterval(interval);
    }, [credentials, sumCredentials]);



    const blinkingAnimationDateTime = {
        fontWeight: "900",
        animation: 'blinkingAnimationDateTime 2s infinite',
        transition: 'color 0.5s ease-in-out',
    }
    const blinkingAnimationBatteryStatusCharging = {
        fontWeight: "900",
        animation: 'blinkingAnimationDateTime 2s infinite',
        transition: 'color 0.5s ease-in-out',
        color: 'green'
    }
    const blinkingAnimationBatteryStatusDischarging = {
        fontWeight: "900",
        animation: 'blinkingAnimationDateTime 2s infinite',
        transition: 'color 0.5s ease-in-out',
        color: 'red'
    }

    const styles = {
        IconStyle: {
            color: 'primary.main',
            fontSize: '1rem'
        }
    }

    return (

        <>
            {/* {LoggedInUserInfo.MNU_WMS === "1" ? (
                <TempInfoStrip />
            ) : null} */}

            {LoggedInUserInfo.MNU_WMS === "1" && LoggedInUserInfo.USER_CATEGORY !== "WMS" && (
                <TempInfoWms />
            )}


            <div className="w-100 " style={{ backgroundColor: "white" }}>
                <div className="row g-0"> {/* Use g-0 to remove horizontal gaps */}

                    <div className="col g-1">
                        <div className="first_total">
                            <div className="card text-center">
                                <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
                                    <strong>Annual Target</strong>
                                </div>
                                <div className="card-body px-2">
                                    {mainData.map((item, indx) => (
                                        <div className="text-start" key={indx}>
                                            <p>Target&nbsp;:&nbsp;<span style={{ fontSize: "1.2rem", color: "#013b7b" }}>
                                                {item.Target !== undefined ? item.Target : "N/A"}
                                            </span>&nbsp;
                                                <span style={{ color: "red" }}>{item.Target_unit !== undefined ? item.Target_unit : "N/A"}</span></p>

                                            &nbsp;

                                            <p>Achieved&nbsp;:&nbsp;<span style={{ fontSize: "1.2rem", color: "#013b7b" }}>
                                                {item.Achieved !== undefined ? item.Achieved : "N/A"}
                                            </span>&nbsp;
                                                <span style={{ color: "red" }}>{item.Target_unit !== undefined ? item.Target_unit : "N/A"}</span></p>
                                            &nbsp;

                                            <p>Target&nbsp;Achieved&nbsp;:&nbsp;<span style={{ fontSize: "1.2rem", color: "#013b7b" }}>
                                                {item.Achieved_per !== undefined ? item.Achieved_per : "N/A"}
                                            </span>
                                            </p>

                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col g-1">
                        <div className="first_total">
                            <div className="card text-center">
                                <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
                                    <strong>Solar Yield</strong>
                                </div>
                                <div className="card-body px-2">
                                    <div>
                                        <img
                                            style={{ display: "flex", marginBottom: "1rem" }}
                                            src={Solarpic}
                                            alt="Solarpic"
                                            className="dashboard-icon"
                                        />

                                        {logData.map((log, index) => (
                                            <div className='d-flex align-items-center my-1' key={index}>
                                                <p style={{ fontSize: "14px" }}>

                                                    <span style={{ fontSize: "1.4rem", color: "#013b7b" }}>
                                                        {log.SOLAR !== undefined ? log.SOLAR : "N/A"}
                                                    </span>&nbsp;&nbsp;
                                                    <span style={{ color: "red" }}>kW</span>
                                                </p>
                                            </div>
                                        ))}
                                    </div>

                                    {mainData.map((item, indx) => (
                                        <div className="text-end" key={indx}>
                                            <p>Today Yield</p>
                                            <p>
                                                <span className="bold" style={{ color: "#013b7b" }}>
                                                    {item.SOLAR_DAY !== undefined ? item.SOLAR_DAY : "N/A"}&nbsp;

                                                </span>
                                                <span>kWh</span>
                                            </p>
                                            <p>Total Yield</p>
                                            <p>
                                                <span className="bold" style={{ color: "#013b7b" }}>
                                                    {item.SOLAR_TOTAL !== undefined ? item.SOLAR_TOTAL : "N/A"}&nbsp;

                                                </span>
                                                <span>kWh</span>
                                            </p>

                                        </div>
                                    ))}


                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="col g-1">
                        <div className="first_total">
                            <div className="card text-center">
                                <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
                                    <strong>Solar Meter</strong>
                                </div>
                                <div className="card-body px-2">
                                    <div><img style={{ display: "flex", marginBottom: "1rem", borderRadius: "1rem" }} src={SolarMeter} alt="grid" className="dashboard-icon" />
                                        {logData.map((log, index) => (
                                            <div className='d-flex align-items-center' key={index}><p style={{ fontSize: "14px" }}>
                                                <span style={{ fontSize: "1.4rem", color: "#013b7b" }}>
                                                    {log.SOLAR_MT !== undefined ? log.SOLAR_MT : "N/A"}
                                                </span>&nbsp;&nbsp;
                                                <span style={{ color: "red" }}>kW</span></p>
                                            </div>
                                        ))}
                                    </div>


                                    {mainData.map((item, indx) => (
                                        <div className="text-end" key={indx}>
                                            <p>Today </p>
                                            <p>
                                                <span className="bold" style={{ color: "#013b7b" }}>
                                                    {item.SOLAR_DAY_MT !== undefined ? item.SOLAR_DAY_MT : "N/A"}&nbsp;

                                                </span>
                                                <span>kWh</span>
                                            </p>
                                            <p>Total </p>
                                            <p>
                                                <span className="bold" style={{ color: "#013b7b" }}>
                                                    {item.SOLAR_TOTAL_MT !== undefined ? item.SOLAR_TOTAL_MT : "N/A"}&nbsp;

                                                </span>
                                                <span>kWh</span>
                                            </p>

                                        </div>
                                    ))}


                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="col g-1">
                        <div className="first_total">
                            <div className="card text-center">
                                <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
                                    <strong>Main ABT Meter</strong>
                                </div>
                                <div className="card-body px-2">
                                    <div><img style={{ display: "flex", marginBottom: "1rem" }} src={Grid1} alt="watch" className="dashboard-icon" />
                                        {logData.map((log, index) => (
                                            <div className='d-flex align-items-center' key={index}><p style={{ fontSize: "14px" }}>
                                                <span style={{ fontSize: "1.4rem", color: "#013b7b" }}>
                                                    {log.NET_MT !== undefined ? log.NET_MT : "N/A"}
                                                </span>&nbsp;&nbsp;
                                                <span style={{ color: "red" }}>kW</span></p>
                                            </div>
                                        ))}
                                    </div>



                                    {mainData.map((item, indx) => (
                                        <div className="text-end" key={indx}>
                                            <p>Today </p>
                                            <p>
                                                <span className="bold" style={{ color: "#013b7b" }}>
                                                    {item.NET_DAY_MT !== undefined ? item.NET_DAY_MT : "N/A"}&nbsp;

                                                </span>
                                                <span>kWh</span>
                                            </p>
                                            <p>Total </p>
                                            <p>
                                                <span className="bold" style={{ color: "#013b7b" }}>
                                                    {item.NET_TOTAL_MT !== undefined ? item.NET_TOTAL_MT : "N/A"}&nbsp;

                                                </span>
                                                <span>kWh</span>
                                            </p>

                                        </div>
                                    ))}

                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="col g-1">
                        <div className="first_total" >
                            <div className="card text-center">
                                <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
                                    <strong>Check Meter</strong>
                                </div>


                                <div className="card-body px-2">
                                    <div><img style={{ display: "flex", marginBottom: "1rem" }} src={Grid1} alt="watch" className="dashboard-icon" />
                                        {logData.map((log, index) => (
                                            <div className='d-flex align-items-center' key={index}>
                                                <p style={{ fontSize: "14px" }}>
                                                    <span style={{ fontSize: "1.4rem", color: "#013b7b" }}>
                                                        {log.CHECK_MT !== undefined ? log.CHECK_MT : "N/A"}
                                                    </span>&nbsp;&nbsp;
                                                    <span style={{ color: "red" }}>kW</span></p>
                                            </div>
                                        ))}
                                    </div>



                                    {mainData.map((item, indx) => (
                                        <div className="text-end" key={indx}>
                                            <p>Today </p>
                                            <p>
                                                <span className="bold" style={{ color: "#013b7b" }}>
                                                    {item.CHECK_DAY_MT !== undefined ? item.CHECK_DAY_MT : "N/A"}&nbsp;

                                                </span>
                                                <span>kWh</span>
                                            </p>
                                            <p>Total </p>
                                            <p>
                                                <span className="bold" style={{ color: "#013b7b" }}>
                                                    {item.CHECK_TOTAL_MT !== undefined ? item.CHECK_TOTAL_MT : "N/A"}&nbsp;

                                                </span>
                                                <span>kWh</span>
                                            </p>

                                        </div>
                                    ))}

                                </div>


                            </div>
                        </div>
                    </div>



                    {mainData.map((log, index) => (
                        <div className="col g-1" key={index}>
                            <div className="first_total">
                                <div className="card">
                                    <div className="card-header text-center" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
                                        <strong>Today's Performance</strong>
                                    </div>
                                    <div className="card-body px-3">

                                        <div className="d-flex justify-content-start w-100">


                                            <div className="leftdiv">
                                                <p><span>CUF</span> &nbsp;<span style={{ fontSize: "1rem", color: "#013b7b" }}>
                                                    {log.CUF !== undefined ? log.CUF : "N/A"}
                                                </span>&nbsp;
                                                    <span className=""> PR</span>&nbsp;
                                                    <span style={{ fontSize: "1rem", color: "#013b7b" }}>
                                                        {log.PR !== undefined ? log.PR : "N/A"}
                                                    </span>
                                                </p>


                                                <p><span>Expected[kWh]</span>&nbsp;
                                                    <span style={{ fontSize: "1rem", color: "#013b7b" }}>
                                                        {log["EXPECT_GEN[KWH]"] !== undefined ? log["EXPECT_GEN[KWH]"] : "N/A"}

                                                    </span>
                                                </p>
                                                <p><span>Peak&nbsp;Irradiance[W/m²]</span>&nbsp;
                                                    <span style={{ fontSize: "1rem", color: "#013b7b" }}>
                                                        {log.PEAK_IRRADIANCE !== undefined ? log.PEAK_IRRADIANCE : "N/A"}
                                                    </span>
                                                </p>
                                                <p><span>Peak&nbsp;Irr&nbsp;Time</span>&nbsp;
                                                    <span style={{ fontSize: "1rem", color: "#013b7b" }}>
                                                        {log.PEAK_IRR_TIME !== undefined ? log.PEAK_IRR_TIME : "N/A"}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    ))}



                </div>
            </div>


            {/* <SolarSvg1 svgColor={palette.primary.main} /> */}



            <Grid container style={{ padding: "0", margin: "0" }}>
                {logData.map((log, index) => (
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6} padding={spacing(0)}>
                        <Container sx={{ maxWidth: '100%', height: '90%', position: 'relative', }}>

                            <Box sx={{ width: '100%', height: '100%' }}>
                                <SolarImageSvg svgColor={palette.primary.main} />


                                <Typography variant='body2' sx={{ position: 'absolute', top: '3%', left: '2%', color: "red" }} className="blink">
                                    {log.IRR !== undefined ? log.IRR : "N/A"} W/m<sup>2</sup>
                                </Typography>

                                <Typography variant='body2' sx={{ position: 'absolute', top: '51%', left: '7%', color: "red" }} className="blink">
                                    {log.PLANT_2 !== undefined ? log.PLANT_2 : "N/A"}
                                </Typography>

                                {/* <Typography variant='body2' sx={{ position: 'absolute', top: '5.5%', right: '13%', color: "red" }} >
                                <img style={{ borderRadius: "1rem", height: "4.5rem", width: "9rem" }} src={Kusum} alt="grid" />
                            </Typography> */}

                                <Typography
                                    variant="body2"
                                    sx={{
                                        position: "absolute",
                                        // top: "30%",
                                        // left: "20%",
                                        top: "11%", left: "42%",
                                        color: "red", // Apply red color directly via sx
                                    }}
                                    className="blink" // Add the blink class for animation
                                >
                                    {log.SOLAR !== undefined ? log.SOLAR : "N/A"} Kw
                                </Typography>


                                <Typography variant="body2" sx={{ position: "absolute", top: "42%", left: "42%", }}>
                                    Solar Meter
                                </Typography>

                                <Typography variant="body2" sx={{ position: "absolute", top: "15%", left: "42%", }}>
                                    Inverters
                                </Typography>

                                <Typography
                                    variant="body2"
                                    sx={{
                                        position: "absolute",
                                        top: "5%",
                                        right: "20%",
                                        color:
                                            log.PLANT_STATUS?.toLowerCase() === "plant online"
                                                ? "green"
                                                : log.PLANT_STATUS?.toLowerCase() === "plant offline"
                                                    ? "red"
                                                    : "inherit", // fallback if status is something else or undefined
                                    }}
                                >
                                    {log.PLANT_STATUS !== undefined ? log.PLANT_STATUS : "N/A"}
                                </Typography>



                                <Typography variant='body2' sx={{ position: 'absolute', top: '"34%"', left: '0%' }}>
                                    Power To Building
                                </Typography>


                                <Typography variant='body2' sx={{ position: 'absolute', top: '"34%"', left: '25%' }}>
                                    MainService Panel
                                </Typography>

                                <Typography variant='body2' sx={{ position: 'absolute', top: '"34%"', left: '51%' }}>
                                    Check Meter
                                </Typography>

                                <Typography variant='body2' sx={{ position: 'absolute', top: '"34%"', left: '69%' }}>
                                    Main Meter
                                </Typography>

                                <Typography variant='body2' sx={{ position: 'absolute', top: '"34%"', right: '5%' }}>
                                    Grid
                                </Typography>


                                <Typography variant='body2' sx={{ position: 'absolute', bottom: '32%', left: '29%' }}  >
                                    Line
                                </Typography>

                                <Typography variant='body2' sx={{ position: 'absolute', bottom: '32%', left: '36%' }}  >
                                    Loss
                                </Typography>

                                <Typography variant='body2' sx={{ position: 'absolute', bottom: '32%', left: '43%', color: "red" }} className="blink" >
                                    {log.NET_LOSS !== undefined ? log.NET_LOSS : "N/A"} Kw
                                </Typography>



                                <Typography variant='body2' sx={{ position: 'absolute', top: '35%', right: '50%', color: "red" }} className="blink" >
                                    {log.SOLAR_MT !== undefined ? log.SOLAR_MT : "N/A"} kW
                                </Typography>

                                <Typography variant='body2' sx={{ position: 'absolute', top: '54%', right: '17%', color: "red" }} className="blink" >
                                    {log.NET_FEQ !== undefined ? log.NET_FEQ : "N/A"} &nbsp;
                                    Hz
                                </Typography>



                                <Typography variant='body2' sx={{ position: 'absolute', bottom: '25%', right: '43%', color: "red" }} className="blink" >
                                    {log.CHECK_MT !== undefined ? log.CHECK_MT : "N/A"} Kw
                                </Typography>


                                <Typography variant='body2' sx={{ position: 'absolute', bottom: '25%', right: '26%', color: "red" }} className="blink" >
                                    {log.NET_MT !== undefined ? log.NET_MT : "N/A"} Kw
                                </Typography>
                            </Box>

                        </Container>
                    </Grid>
                ))}


                <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={{ overflow: 'hidden' }}>

                    <Stack rowGap={spacing(0)} sx={{ marginTop: '.4rem', marginBottom: '.4rem', overflow: 'hidden' }}>

                        <Stack
                            component={Card}
                            p={spacing(1)}
                            sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(2) }}
                        >
                            <MainSlider />
                        </Stack>

                        <Tab4MonthlyEnergy />
                        {/* <Stack component={Card} p={spacing(1)} sx={{ height: '19rem', overflow: 'hidden' }}>

                            <Tab4MonthlyEnergy />

                        </Stack> */}
                    </Stack>


                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} padding={spacing(0)}>

                    <Stack
                        component={Card}
                        p={spacing(1)}
                        sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(2) }}
                    >
                        <PlantEnergy />
                    </Stack>
                </Grid>


            </Grid>

            <BottomSlider />

        </>
    );
}


export default memo(DashboardKusumTab1)